

import action from './action';
import * as F from 'utils/F';
import Icon from 'vux/src/components/icon/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'

import { NavBar, yoButton, addressSelect } from 'components';
import { dateFormat } from 'utils/filters';
import 'vant/lib/vant-css/submit-bar.css';

import {
Card,
CellGroup,
Switch,
SwitchCell,
Tag,
Row,
Col,
Cell,
Popup,
Tab,
Tabs,
Rate,
Sku,
Button,
CheckboxGroup,
Checkbox,
RadioGroup,
Radio,
Field
} from 'vant';

export default {
name: 'page',
props: ['params'],
metaInfo: {
title: '确认订单'
},
components: {
Icon,
yoButton,
NavBar,
'van-switch': Switch,
CellGroup,
SwitchCell,
'van-tag': Tag,
Row,
'van-col': Col,
Cell,
'van-popup': Popup,
'van-button': Button,
'van-sku': Sku,
Tab,
Tabs,
Rate,
addressSelect,
'van-field': Field,
'van-checkbox-group': CheckboxGroup,
'van-radio-group': RadioGroup,
'van-checkbox': Checkbox,
'van-radio': Radio,
XTextarea
},
created() {
console.log("G.member", G.member)
this.getAddressList();
console.log('selectedCoupon', this.selectedCoupon);
},
data() {
const settlement = JSON.parse(localStorage.getItem('settlement'));
console.log('settlement', settlement);
return {
showSale: false,//促销
showVoucher1: false,
showAddress: false,
showEditAddress: false,
selectedAddress: settlement.deliveryAddress,
settlement: settlement,
postData: {
cartId: this.params.cartId,
goodsInfoId: this.params.goodsInfoId,
goodsNum: this.params.goodsNum,
productId: 1,
deliveryWay: settlement.deliveryWay || 1,
deliveryAddress: settlement.deliveryAddress,
deliveryAddressId: settlement.deliveryAddress ? settlement.deliveryAddress.deliveryAddressId : undefined,
usedCoinState: settlement.usedCoinState,
storeId: settlement.storeId,
useId: settlement.useId,
leaveMessage: undefined
},
addressForm: {},
coupons: [],
selectedCoupon: settlement.useId,
showCoupons: false,
addressList: {
items: []
},
showFullExtension: false
};
},
computed: {
businessActivity: function () {
const settlement = this.settlement;
return !settlement ? [] : settlement.businessActivity ? settlement.businessActivity : [];
},
businessActivities: function () {
const settlement = this.settlement;
return !settlement ? [] : settlement.businessActivities ? settlement.businessActivities : [];
},
deliveryAddress: function () {
return this.postData.deliveryAddress;
},
formatOrderShoppingCarts() {
let orderShoppingCarts = this.settlement.orderShoppingCarts || [];






console.log('-------------formatOrderShoppingCarts', orderShoppingCarts);
if (orderShoppingCarts && orderShoppingCarts.length > 0) {
let newdata = orderShoppingCarts.map(item => {
let goodsLabel = (item.goodsLabel || []).map(item => {
const { labelName, labelColor, labelBGColor, labelBorderColor } = item;
return {
...item,
style: `background-color: ${labelBGColor}; color: ${labelColor}; border-color: ${labelBorderColor}`
};
});
let activityLabel = (item.activityLabel || []).map(item => {
return {
...item,
style: `background-color: ${item.labelBGColor || '#ff5775'}; color: ${item.labelColor || '#fff'}; border-color: ${item.labelBorderColor || 'transparent'}`
};
});
console.log('-------------orderShoppingCarts', goodsLabel, activityLabel, {
...item,
goodsLabel,
activityLabel
});
return {
...item,
goodsLabel,
activityLabel
};
});
console.log('------------newdata', newdata);
return newdata;
} else {
return [];
}
}
},
filters: {
dateFormat
},
methods: {
...action
}
};



// WEBPACK FOOTER //
// ./src/module/cart/settlement/page.vue